import api from '../request/api/index'
import Vue from 'vue'
const usercenter = {
    state:{
        token: window.localStorage.getItem('token') ||'',
        userinfo: JSON.parse(localStorage.getItem('userinfos')) || {
            gender: 0,
            chatroom_id: "",
            id:0,
            coin_num: 0,
            mess_num:0,
            grade: 1,
            portrait: "",
            reg_days: 0,
            register_time: "",
            room_manage: 0,
            user_nickname: "",
            today_experience:"0",
            userid: "",
            status:"",
            experience:"0",
            mobile:'11111111111',
            next_experience:"0",
            diamond_num: 0
          },
        asideIndex: -1,
        croopDialog:false,
        userDialog:false,
        current_sportid: '',
        current_eventid: '',
        current_datetim: '',
        mainDialog:false,
        Guessdata:{},
    },
    getters:{

    },
    mutations:{
        setToken(state,token){
            state.token = token
            window.localStorage.setItem('token',token)
        },
        setasideIndex(state,index){
            state.asideIndex = index
        },
        setCroopDialog(state,flag){
            state.croopDialog = flag
        },
        setUserDialog(state,flag){
            state.userDialog = flag
        },
        setUserIfno(state, userinfo){
            // //console.log('我是vuex中的userinfo',userinfo)
            if(JSON.stringify(userinfo) == '{}'){
              state.userinfo = {
                gender: 0,
                chatroom_id: "",
                id:0,
                coin_num: 0,
                mess_num:0,
                grade: 1,
                portrait: "",
                reg_days: 0,
                register_time: "",
                room_manage: 0,
                user_nickname: "",
                today_experience:"",
                userid: "",
                status:"",
                experience:"",
                mobile:'11111111111',
                next_experience:"",
                userid:'',
              }
              window.localStorage.setItem('userinfos', JSON.stringify(userinfo))
            }else{
              state.userinfo = Object.assign({},  userinfo)
              window.localStorage.setItem('userinfos', JSON.stringify(userinfo))
            }
        },
        setSportId(state,id){
          state.current_sportid = id
        },
        setEventtId(state,id){
          state.current_eventid = id
        },
        setEventTime(state,time){
          state.current_datetim = time
        },
        setGuessdata(state,data){
          state.Guessdata = data
        },
        setmainDialog(state,data){
          state.mainDialog = data
        }
    },
    actions:{
       getUserInfo(content){
         return new Promise((resolve,reject)=>{
           api.getUserInfo({}).then((res)=>{
             // 仅 200 走业务数据；其余（27/401/510 等）一律按空对象 resolve，
             // 与原版 resolve({}) 等价，保持调用方契约不变
             resolve(res.code == 200 ? res.data : {})
           }).catch((error)=>{
              reject(error)
           })
         })
       }
    }
}
export default usercenter